import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface WordPressIdeaProjectsProps {
    wordPressData: any
}

const WordPressIdeaProjects: FC<WordPressIdeaProjectsProps> = ({ wordPressData }) => {
    return (
        <div>
            <div className='flex flex-col gap-5 md:gap-8 lg:gap-10 bg-darkGreyPrimary mt-4 md:mt-6 lg:mt-8'>
                {wordPressData.WordPressIdeaProjectsData.map((projects: any, index: number) => {
                     let img = getImage(projects.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            className={`flex-col md:flex-${projects.row} flex px-4 sm:px-6 md:px-10 lg:px-20 xl:px-40 h-auto md:h-96`}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.2, delay: index * 0.1 }}
                        >
                            <motion.div 
                                className={classNames(
                                    'flex flex-col w-full md:w-2/4 p-6 md:pl-10 md:pr-10 lg:pr-36', 
                                    `justify-center bg-blackDark`
                                )}
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.2, delay: index * 0.2 + 0.2 }}
                            >
                                <motion.div 
                                    className={classNames('font-semibold text-2xl md:text-3xl lg:text-4xl', `text-${projects.textColor}`)}
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    transition={{ duration: 0.2, delay: index * 0.2 + 0.4 }}
                                >{projects.key}.</motion.div>
                                <motion.div 
                                    className={classNames('font-semibold text-2xl md:text-3xl lg:text-4xl', `text-${projects.textColor}`)}
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >{projects.title}</motion.div>
                                <motion.div 
                                    className={classNames('text-[#E0E0E0] text-base md:text-lg pt-3 md:pt-4', `text-${projects.text}`)}
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >{projects.subtitle}</motion.div>
                            </motion.div>
                            <motion.div 
                                className={`w-full md:w-[30%] h-auto overflow-hidden bg-blackDarkThemePrimary md:-ml-16 my-4 md:my-8`}
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4 }}
                            >
                                {/* <motion.img 
                                    src={projects.image} 
                                    className='w-full p-4 h-full object-contain'
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ duration: 0.3 }}
                                /> */}
                                <DynamicSVG size='w-full p-4 h-full object-contain'>{img}</DynamicSVG>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default WordPressIdeaProjects
